<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="img/avatars/6.jpg"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    <!-- <CDropdownItem>
      <CIcon name="cil-bell"/> Updates
      <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> Messages
      <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <!-- <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-user" />{{ userProfile.email}}
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-dollar" /> Payments
      <!-- <CBadge color="secondary" class="ml-auto">{{ itemsCount }}</CBadge> -->
    </CDropdownItem>
    <CDropdownItem @click="changePassword()">
      <CIcon name="cil-keyboard" /> Change password
      <!-- <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge> -->
    </CDropdownItem>
    <CDropdownDivider/>
    <!-- <CDropdownItem>
      <CIcon name="cil-shield-alt" /> Lock Account
    </CDropdownItem> -->
    <CDropdownItem @click="mgr.signOut()">
      <CIcon name="cil-lock-locked"  /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
/* eslint-disable */
import Mgr from '../services/SecurityService'

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      mgr: new Mgr(), 
      itemsCount: 42,
      userProfile: {
        given_name: ''
      }
    }
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    changePassword() {
      this.$router.push({path: 'changepassword'});
    },
    getProfile(){
      let self = this
      this.mgr.getProfile().then(
        tokenProfile => {
          console.log(tokenProfile);
          this.userProfile = tokenProfile;          
        },
        err => {
          console.log(err)
      })
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>